'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Input = require('./components/form-fields/Input.js');
var TextArea = require('./components/form-fields/TextArea.js');
var Select = require('./components/form-fields/Select.js');
var Checkbox = require('./components/form-fields/Checkbox.js');
var RadioGroup = require('./components/form-fields/RadioGroup.js');
var AddButton = require('./components/form-fields/AddButton.js');
var RemoveButton = require('./components/form-fields/RemoveButton.js');
var ArrayField = require('./components/form-fields/ArrayField.js');
var Hidden = require('./components/form-fields/Hidden.js');

var FieldMap = {
  string: Input.Input,
  number: Input.Input,
  "boolean": Checkbox.Checkbox,
  select: Select.Select,
  input: Input.Input,
  textarea: TextArea.TextArea,
  checkbox: Checkbox.Checkbox,
  radio: RadioGroup.RadioGroup,
  add: AddButton.AddButton,
  remove: RemoveButton.RemoveButton,
  hidden: Hidden.Hidden,
  array: ArrayField.ArrayField,
  withOptions: {
    string: Select.Select
  }
};

exports.FieldMap = FieldMap;
